<template>
  <div v-if="customerPrices.length > 0" class="price-diff">
    <div v-for="(priceDiff, index) in customerPrices" :key="index" class="price-diff-row mb-2">
      <div class="price-diff-label">
        {{ priceDiff.name }} - {{ ucFirst(priceDiff.destination) }} -
        {{ priceDiff.countryCode ? priceDiff.countryCode : priceDiff.countryGroup }}
      </div>
      <div class="price-diff-list-diffs">
        <div v-for="(diff, diffIndex) in priceDiff.diff" :key="diffIndex">
          <div v-if="priceDiff.mode === TIER" class="price-diff-item d-flex">
            <div class="mr-2 price-diff-item-field">{{ normalizeName(diff.field) }}</div>
            <div class="mr-2">{{ formattedPrice(diff.base) }}</div>
            <mdicon name="ChevronDoubleRight" size="18" class="price-diff-arrow" />
            <div class="ml-2">{{ formattedPrice(diff.company) }}</div>
          </div>
          <div v-else-if="priceDiff.mode === WEIGHT" class="price-diff-item d-flex align-items-center">
            <div class="mr-2">
              <div
                v-for="(diffW, diffWIndex) in diff.base"
                :key="diffWIndex"
                class="d-flex justify-content-between align-items-center w-100"
              >
                <span class="mr-2">{{ diffW.min_weight }} - {{ diffW.max_weight }}</span>
                <span>{{ formattedPrice(diffW.price) }}</span>
              </div>
            </div>
            <mdicon name="ChevronDoubleRight" size="18" class="price-diff-arrow" />
            <div class="ml-2">
              <div
                v-for="(diffW, diffWIndex) in diff.company"
                :key="diffWIndex"
                class="d-flex align-items-center justify-content-between w-100"
              >
                <span class="mr-2">{{ diffW.min_weight }} - {{ diffW.max_weight }}</span>
                <span>{{ formattedPrice(diffW.price) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PriceDifference } from '@/types/Models/BasePrice'
import { defineComponent } from 'vue'
import { TIER, WEIGHT } from '@/const/PriceModes'
import { formattedPrice, ucFirst } from '@/services/Helpers'
import { normalizeName } from '@/services/Utils'

export default defineComponent({
  name: 'PriceDifference',
  props: {
    customerPrices: {
      type: Array as () => PriceDifference[],
      required: true,
    },
  },
  setup() {
    return {
      formattedPrice,
      normalizeName,
      ucFirst,
      TIER,
      WEIGHT,
    }
  },
})
</script>
